import { createSelector } from 'reselect';
import { getEntry } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getOwnerByUserId } from './getOwnerByUserId';
const getUserIdFromProps = (_, {
  userId
}) => userId;
export const getAsyncOwnerByUserId = createSelector([getOwnerByUserId, getUserIdFromProps],
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
(ownerData, userId) => getEntry(userId, ownerData));